export default __webpack_public_path__ + "static/media/pic4-1.f0ae8dfc.jpg";